import useProjectViews from '@API/project/useProjectViews';

const getDefaultProjectView = views => {
  return views.find(view => view.projectDefault);
};

export default function useDefaultProjectView() {
  return useProjectViews({
    select: getDefaultProjectView
  });
}
